import { observer } from 'mobx-react';
import { useRef } from 'react';
import clickOutsideStore from '../../../../../../ClickOutsideStore';
import { T } from '../../../../../../Translations';
import { OfferingType } from '../../../../Types';
import { getUtilizedOfferingTypes } from '../Types';
import ChevronIcon from './ChevronIcon';
import CounterIcon from './CounterIcon';

interface Props {
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>;
  productLicenseOfferingTypes: ReadonlyArray<OfferingType>;
  setOverviewActive: (active: boolean) => void;
  overviewActive: boolean;
}

function Banner({
  learningDesignOfferingTypes,
  productLicenseOfferingTypes,
  setOverviewActive,
  overviewActive,
}: Props) {
  const utilized = getUtilizedOfferingTypes(
    productLicenseOfferingTypes,
    learningDesignOfferingTypes,
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  const close = () => {
    setOverviewActive(false);
  };

  const open = () => {
    clickOutsideStore.addListener({
      ref: dropdownRef,
      callback: close,
    });
    setOverviewActive(!overviewActive);
  };

  return (
    <div className="flex flex-row justify-center items-center">
      <div className="my-auto">
        <CounterIcon utilized={utilized.length} total={productLicenseOfferingTypes.length} />
      </div>
      <div className="mx-3 text-sm">
        <T
          kind="{{utilizationCount}} of {{productTypeCount}} program types included"
          utilizationCount={utilized.length}
          productTypeCount={productLicenseOfferingTypes.length}
        />
      </div>
      <div className="h-5 w-5 my-auto">
        <div onClick={open} ref={dropdownRef} className="cursor-pointer">
          <ChevronIcon overviewActive={overviewActive} />
        </div>
      </div>
    </div>
  );
}

export default observer(Banner);
